/**
 * ? @description : App Component
 */

// Dependencies
import React from "react";

// CSS Component
import "./App.css";

// Components
import { Route, Routes } from 'react-router-dom'
import MainPage from "./components/MainPage";
import EndPageModal from "./components/student-module/EndPageModal";

function App() {
  return (
    <>
  <Routes>
    <Route path="/" element={<MainPage/>}/>
    <Route path="end" element={<EndPageModal/>}/>

  </Routes>
    </>
  );
}

export default App;
